<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.quest_practices'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:grid md:grid-cols-2 md:gap-6">
            <div>
                <div>
                    <ApexGraph :options="graphs.log_types" />
                </div>
            </div>

            <div v-if="meta.info.calendar_graph_widget" class="mt-3">
                <AppWell>
                    <div>
                        <CalendarChartWidget :widget="meta.info.calendar_graph_widget" />
                    </div>
                </AppWell>
            </div>
        </div>

        <div class="mt-5">
            <ApexGraph :options="graphs.tag_levels" />
        </div>

        <div>
            <pre>{{meta.info.totals}}</pre>
        </div>

    </PanelPage>
</template>

<script>
import CentralLayout from '@/Shared/CentralLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import AppButton from '@/components/AppButton.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import AppWell from '@/Shared/AppWell.vue';
import CalendarChartWidget from '@/components/Widgets/Teacher/CalendarChartWidget.vue';
import BadgePill from '@/components/BadgePill.vue';
import ApexGraph from '@/components/ApexGraph.vue';

export default {
    components: {
        ApexGraph,
        BadgePill,
        CalendarChartWidget,
        AppWell,
        SubmitFormButton,
        AppButton,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
    },
    layout: CentralLayout,
    name: 'Index',
    props: ['meta', 'graphs', 'filters'],
    data() {
        return {
            form: this.$inertia.form({}),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
